export default "__VITE_ASSET__0cab9a35__"